import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/assets/locales/en.json";
import ru from "@/assets/locales/ru.json";
import uz from "@/assets/locales/uz.json";

export const LANGUAGES = ["uz", "ru", "en"] as const;
export type Language = (typeof LANGUAGES)[number];

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "uz",
    supportedLngs: LANGUAGES,
    // Admin panelda URL tilni ko'rsatmaydi (SEO kerak emas), shuning uchun
    // tanlov localStorage'da saqlanadi.
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
    interpolation: { escapeValue: false },
    resources: {
      uz: { translation: uz },
      ru: { translation: ru },
      en: { translation: en },
    },
  });

export default i18next;
